import { Select } from "antd";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import "./index.less";
import { language } from "@/utils/language";
// 城市题
function City(props) {
  const [answer, setAnswer] = useState([{}, {}, {}]);
  const [prov, setProv] = useState([]);
  const [city, setCity] = useState([]);
  const [area, setArea] = useState([]);
  const [hashMap, setHashMap] = useState({});
  const [provinceCode, setProvinceCode] = useState(null);
  const [cityCode, setCityCode] = useState(null);
  const [districtCode, setDistrictCode] = useState(null);
  const [data, setData] = useState([]);

  const {
    info: { cityShowType, region, id },
  } = props;

  useEffect(() => {
    try {
      const { answer } = props;
      console.log("24 line: ", answer, id);
      const { province, city, district } = answer[id];
      const other = { label: "其他", value: "-1" };
      let code1, code2, code3, label;
      try {
        [code1, label] = province?.text.split(":");
        setProvinceCode(label);
        data.map((prov) => {
          if (prov.value === code1) {
            const { codes } = region[1];
            setCity([
              ...prov.children.filter((city) => codes.includes(city.value)),
              other,
            ]);
          }
        });
      } catch (error) {}
      try {
        [code2, label] = city?.text.split(":");
        setCityCode(label);
        data.map((prov) => {
          prov.children.map((city) => {
            const { codes } = region[2];
            if (city.value === code2) {
              setArea([
                ...city.children.filter((area) => codes.includes(area.value)),
                other,
              ]);
            }
          });
        });
      } catch (error) {}
      [code3, label] = district?.text.split(":");
      setDistrictCode(label);
      setAnswer([
        { level: 1, code: code1 },
        { level: 2, code: code2 },
        { level: 3, code: code3 },
      ]);
    } catch (error) {
      console.log("error line: ", error.message);
    }
  }, [props.answer, data]);

  useEffect(() => {
    axios.get(`/china.json`).then(({ data: { data } }) => {
      setData(data);
      const map = {};
      const setMap = (item) => {
        map[item.value] = item.label;
        if (item.children) item.children.map(setMap);
      };
      data.map(setMap);
      setHashMap(map);

      const [provObj, cityObj, areaObj] = region;
      const array = [];
      switch (cityShowType) {
        case 0:
        case 1:
        case 2:
          data.map((item) => {
            if (provObj.codes.includes(item.value)) {
              if (item.value !== "-1") array.push(item);
            }
            return 0;
          });
          array.push({ label: "其他", value: "-1" });
          setProv(array);
          break;
        case 3:
        case 4:
          data.map((item) => {
            if (provObj.codes.includes(item.value)) {
              (item.children || []).map((item) => {
                if (cityObj.codes.includes(item.value)) {
                  if (item.value !== "-1") array.push(item);
                }
                return 0;
              });
            }
            return 0;
          });
          array.push({ label: "其他", value: "-1" });
          setCity(array);
          break;
        case 5:
          data.map((item) => {
            if (provObj.codes.includes(item.value)) {
              (item.children || []).map((item) => {
                if (cityObj.codes.includes(item.value)) {
                  (item.children || []).map((item) => {
                    if (areaObj.codes.includes(item.value)) {
                      if (item.value !== "-1") array.push(item);
                    }
                    return 0;
                  });
                }
                return 0;
              });
            }
            return 0;
          });
          array.push({ label: "其他", value: "-1" });
          setArea(array);
          break;
        default:
          break;
      }
    });
  }, [cityShowType, region]);

  const onChange = (level, code) => {
    try {
      [setProvinceCode, setCityCode, setDistrictCode][level](code);
      answer[level] = { level: level + 1, code };
      if (level === 0) {
        setAnswer([{ level: 1, code }, {}, {}]);
        setCityCode(null);
        setDistrictCode(null);
      } else if (level === 1) {
        const a = answer.find((o) => o.level === 1);
        setAnswer([a, { level: 2, code }, {}]);
        setDistrictCode(null);
      } else {
        setAnswer([...answer]);
      }
      const obj = {};
      answer.map((item) => {
        try {
          const map = { 1: "province", 2: "city", 3: "district" };
          obj[map[item.level]] = {
            text: `${item.code}:${hashMap[item.code] || "其他"}`,
          };
        } catch (error) {}
        return 0;
      });
      if (level === 0) {
        delete obj.city;
        delete obj.district;
      }
      if (level === 1) {
        delete obj.district;
      }
      delete obj.undefined;
      props.changeAnswer(obj);
      const array = [prov, city, area][level];
      const selectedObj = array.filter(({ value }) => code === value)[0];
      const { children = [] } = selectedObj;
      const setNext = [setProv, setCity, setArea][level + 1] || (() => {});
      const { codes } = region[level + 1];
      const data = children.filter(({ value }) => codes.includes(value));
      const other = { label: "其他", value: "-1" };
      if (data.find((item) => item.value === "-1")) setNext(data);
      else setNext([...data, other]);
    } catch {}
  };

  const showStyle = (...rest) => ({
    display: rest.includes(cityShowType) ? "" : "none",
  });

  return (
    <div className="city">
      <div className="q-content">
        <div className="q-content-options">
          <div style={showStyle(0, 1, 2)}>
            <Select
              options={prov}
              placeholder={language().select}
              value={provinceCode}
              onChange={(value) => onChange(0, value)}
            />
          </div>
          <div style={showStyle(0, 1, 3, 4)}>
            <Select
              options={city}
              placeholder={language().select}
              value={cityCode}
              onChange={(value) => onChange(1, value)}
            />
          </div>
          <div style={showStyle(0, 3, 5)}>
            <Select
              options={area}
              placeholder={language().select}
              value={districtCode}
              onChange={(value) => onChange(2, value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default City;
